import Modal from '@/shared/Modal.vue';
import {trackEvent} from '@/services/tracking.js';

export default {
	components: {
		AddStepModal: Modal,
	},
	data: () => ({
		addStepModal: {
			state: false,
			name: null,
			desc: null,
			prevStepName: '',
		},
	}),
	methods: {
		buildAddStep({name, desc, customProduct = false, title = 'Description', key = 'custom-product-0'}) {
			return {
				name,
				stepEnabled: true,
				labNotes: {
					desc: null,
				},
				customContent: {
					title,
					desc,
					customProduct,
				},
				key,
			};
		},
		showAddStepModal(name) {
			trackEvent('ctaClick', {eVar58: 'Add step | Workflow Configurator'});

			// show modal
			this.addStepModal.state = true;

			// cache preceding step by stepNumber
			return (this.addStepModal.prevStepName = name);
		},
		cancelAddWorkflowStep() {
			// close shared modal and remove unused data
			return (this.addStepModal = {state: false, title: '', desc: ''});
		},
		addWorkflowStep() {
			// get preciding step position
			const name = this.addStepModal.prevStepName;

			// pass modal data to build a new step
			const wfs = this.buildAddStep(this.addStepModal);

			// commit step to store
			this.$store.dispatch('workflow/addCustomStep', {name, wfs});

			// reset addStepModal
			this.$root.$emit('changeRegistered');
			return this.cancelAddWorkflowStep();
		},
	},
};
